import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import history from '../../../history';

const getTime = (data) => {
  var sec_num = parseInt(data, 10); // don't forget the second param
  var hours   = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  var seconds = sec_num - (hours * 3600) - (minutes * 60);

  if (hours   < 10) {hours   = "0"+hours;}
  if (minutes < 10) {minutes = "0"+minutes;}
  if (seconds < 10) {seconds = "0"+seconds;}
  return hours + ':' + minutes + ':' + seconds;
}

class StaticItem extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  
  render() {
    const {formatMessage} = this.context;

    const { index, item, questions_length } = this.props;
    const procent = 100 / questions_length * item.true_count_answer;

    const seconds = item.date_end - item.date_start;

    return (
    <div className="StaticItem" onClick={() => {
      history.push(`/student/answer/quiz/${item.quiz_id}/${item.id}`)
    }}> 
      {formatMessage('txtStAttem')} {index+1} ({procent.toFixed(2)}%, {item.true_count_answer} {formatMessage('txtCorrectAnswer')}, {item.count_answer - item.true_count_answer} {formatMessage('txtIncorrectAnswer')}, {questions_length - item.count_answer > 0 ? questions_length - item.count_answer : 0 } {formatMessage('txtInQuestion')}) {moment(item.date_end*1000).format('DD/MM/YYYY HH:mm')} ({getTime(seconds)})</div>
    );
  }
}

export default StaticItem;


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/StatisticReports/QuizAnswers/StaticItem.jsx